import styled from 'styled-components'
import { Col, Row, Button } from 'antd';

const H1 = styled.h1`
  font-family: Varela,sans-serif;
  font-weight: 700;
  font-size: 38px;
  line-height: 44px;
`

const VisionH1 = styled(H1)`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 90px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  font-family: Varela,sans-serif;
  font-weight: 700;
`

const VisionT1 = styled.span`
`

const VisionT2 = styled(VisionT1)`
  margin-left: 10px;
  color: #5668ee;
`

const VisionReadme = styled.p`
  color: #888;
  font-size: 18px;
  text-align: center;
`

const ViewSolution = styled(Row)`
  margin-top: 20px;
`

const ViewSolutionButton = styled(Button)`
  border-color: rgba(59,90,146,.35);
`

const ViewSolutionButton2 = styled(ViewSolutionButton)`
  color: #608ee0;
`

export const Home = () => {
  return (
    <>
      <Row justify="center">
        <Col>
          <VisionH1>
            <VisionT1>Everything you need to </VisionT1><VisionT2>build internal tools</VisionT2>
          </VisionH1>
          <VisionReadme>
            几分钟内构建和部署您需要的一切应用，而无需任何的专业知识
          </VisionReadme>
        </Col>
      </Row>
      <ViewSolution gutter={[16, 0]}  justify="center" align="middle">
        <Col><ViewSolutionButton type="primary" shape="round">试用云平台</ViewSolutionButton></Col>
        <Col><ViewSolutionButton2 shape="round">私有化部署</ViewSolutionButton2></Col>
      </ViewSolution>
    </>
  );
}